module.exports = __webpack_public_path__ + "05_bob_black.2cc4242f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_bob_black.png
// module id = Agmn
// module chunks = 0